module.exports = __webpack_public_path__ + "img/CN_GAMES.f42a52ac.png";